export default __webpack_public_path__ + "static/step0301-b99e0f2a941d010e72fd98829dba71d3.png";